import http_request from './http_request'
import config from 'config'

function getAssociatedUserFromDrive(email) {
	return http_request.get(config.api + 'user/getDriveAssociatedUser')
		.send({
			email,
		})
}

export default {
	getAssociatedUserFromDrive,
}
